import type { AxiosRequestConfig } from 'axios'
import { DeliveryType, OrderStatus, PaymentMethod, PaymentStatus, Permission, RefundStatus } from '@jiaofa/constants'
import type { AdminProduct } from './product'

type PageResult<T> = {
  list: T[]
  page: number
  pageSize: number
  total: number
  hasMore: boolean
}

type MockResult = {
  handled: boolean
  data?: unknown
}

type QueryParams = Record<string, unknown>
type MockPointsMallItem = {
  id: string
  type: string
  name: string
  description?: string
  image?: string
  points: number
  stock: number
  limitPerUser: number
  couponTemplateId?: string
  couponTemplateName?: string
  pickupType?: string
  pickupDesc?: string
  badge?: string
  sort: number
  status: string
  createdAt: string
}
type MockPointsMallExchange = {
  id: string
  itemId: string
  itemName: string
  type: string
  pointsCost: number
  couponId?: string
  pickupCode?: string
  pickupRemark?: string
  status: string
  nickname?: string
  phone?: string
  createdAt: string
  pickedUpAt?: string
}

const now = '2026-08-09 10:30:00'

const mockAdminUser = {
  id: 'mock-admin',
  username: 'admin',
  nickname: '演示管理员',
  roles: ['SUPER_ADMIN'],
  permissions: ['*'],
}

const stores = [
  { id: '1', name: '高新科技园店', code: 'JF-GX-001', address: '高新区云创路 88 号', phone: '028-88000001', longitude: 104.066, latitude: 30.572, businessStatus: 'OPEN', supportsDelivery: true, supportsDrone: true, openTime: '08:00', closeTime: '22:30', createdAt: '2026-07-01 09:00:00' },
  { id: '2', name: '万象城店', code: 'JF-WX-002', address: '成华区双庆路 8 号', phone: '028-88000002', longitude: 104.112, latitude: 30.658, businessStatus: 'OPEN', supportsDelivery: true, supportsDrone: false, openTime: '09:30', closeTime: '23:00', createdAt: '2026-07-08 09:00:00' },
  { id: '3', name: '大学城店', code: 'JF-DX-003', address: '温江区柳台大道 555 号', phone: '028-88000003', longitude: 103.836, latitude: 30.692, businessStatus: 'PAUSED', supportsDelivery: true, supportsDrone: false, openTime: '10:00', closeTime: '22:00', createdAt: '2026-07-18 09:00:00' },
]

const categories = [
  { id: 'cat-1', name: '云咖招牌', tab: 'hot', sort: 1, status: 'ENABLED', supportsDelivery: true, createdAt: now },
  { id: 'cat-2', name: '轻乳茶', tab: 'milk', sort: 2, status: 'ENABLED', supportsDelivery: true, createdAt: now },
  { id: 'cat-3', name: '烘焙甜点', tab: 'bakery', sort: 3, status: 'ENABLED', supportsDelivery: false, createdAt: now },
]

const products: AdminProduct[] = [
  { id: 'prod-1', name: '云顶拿铁', categoryId: 'cat-1', categoryName: '云咖招牌', storeIds: '["1"]', storeNames: '高新科技园店', subtitle: '厚乳拿铁，默认少糖', mainImageUrl: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93', originalPrice: 2600, price: 2400, status: 'ON', supportsDelivery: true, stock: 86, sales: 328, createdAt: now, specGroups: [
    { id: 'sugar', name: '可选糖', required: true, multiple: false, options: [{ id: 'default', name: '默认糖', priceInFen: 0, enabled: true }, { id: 'half', name: '五分糖', priceInFen: 0, enabled: true }] },
    { id: 'temperature', name: '温度偏好', required: true, multiple: false, options: [{ id: 'ice', name: '少冰', priceInFen: 0, enabled: true }, { id: 'hot', name: '热饮', priceInFen: 0, enabled: true }] },
    { id: 'topping', name: '精选小料', required: false, multiple: true, options: [{ id: 'oat', name: '燕麦奶', priceInFen: 300, enabled: true, recommended: true }] },
  ] },
  { id: 'prod-2', name: '桂花乌龙轻乳茶', categoryId: 'cat-2', categoryName: '轻乳茶', storeIds: '["1"]', storeNames: '高新科技园店', subtitle: '桂花香气与乌龙茶底', mainImageUrl: 'https://images.unsplash.com/photo-1525385133512-2f3bdd039054', originalPrice: 2300, price: 2100, status: 'ON', supportsDelivery: true, stock: 120, sales: 276, createdAt: now },
  { id: 'prod-3', name: '黑金芝士蛋糕', categoryId: 'cat-3', categoryName: '烘焙甜点', storeIds: '["2"]', storeNames: '万象城店', subtitle: '单人份低温芝士', mainImageUrl: 'https://images.unsplash.com/photo-1533134242443-d4fd215305ad', originalPrice: 3200, price: 3000, status: 'ON', supportsDelivery: false, stock: 24, sales: 91, createdAt: now },
  { id: 'prod-4', name: '冷萃美式', categoryId: 'cat-1', categoryName: '云咖招牌', storeIds: '["3"]', storeNames: '大学城店', subtitle: '12 小时冷萃', mainImageUrl: 'https://images.unsplash.com/photo-1495474472287-4d71bcdd2085', originalPrice: 2200, price: 2000, status: 'OFF', supportsDelivery: false, stock: 0, sales: 64, createdAt: now },
]

const skus = [
  { id: 'sku-1', productId: 'prod-1', productName: '云顶拿铁', skuCode: 'LATTE-HOT-M', specText: '热 / 中杯', price: 2400, memberPrice: 2200, enabled: true, stock: 56 },
  { id: 'sku-2', productId: 'prod-1', productName: '云顶拿铁', skuCode: 'LATTE-ICE-L', specText: '冰 / 大杯', price: 2700, memberPrice: 2400, enabled: true, stock: 30 },
  { id: 'sku-3', productId: 'prod-2', productName: '桂花乌龙轻乳茶', skuCode: 'OOLONG-L', specText: '大杯 / 少糖', price: 2300, memberPrice: 2000, enabled: true, stock: 120 },
]

const extras = [
  { id: 'extra-1', storeId: '1', name: '燕麦奶', price: 300, recommended: true, status: 'ENABLED', sort: 1 },
  { id: 'extra-2', storeId: '1', name: '浓缩加一份', price: 500, recommended: true, status: 'ENABLED', sort: 2 },
  { id: 'extra-3', storeId: '2', name: '奶盖', price: 400, recommended: false, status: 'DISABLED', sort: 3 },
]

const inventory = [
  { skuId: 'sku-1', productId: 'prod-1', productName: '云顶拿铁', storeId: '1', stock: 56, safetyStock: 20 },
  { skuId: 'sku-2', productId: 'prod-1', productName: '云顶拿铁', storeId: '1', stock: 8, safetyStock: 10 },
  { skuId: 'sku-3', productId: 'prod-2', productName: '桂花乌龙轻乳茶', storeId: '2', stock: 120, safetyStock: 30 },
]

const combos = [
  { id: 'combo-1', storeId: '1', name: '早八活力套餐', originalPrice: 5600, salePrice: 4590, status: 'ENABLED', items: [{ productId: 'prod-1', productName: '云顶拿铁', quantity: 1 }, { productId: 'prod-3', productName: '黑金芝士蛋糕', quantity: 1 }], createdAt: now },
  { id: 'combo-2', storeId: '2', name: '办公室下午茶', originalPrice: 9200, salePrice: 7990, status: 'ENABLED', items: [{ productId: 'prod-2', productName: '桂花乌龙轻乳茶', quantity: 4 }], createdAt: now },
]

const orders = [
  { id: 'order-1', orderNo: 'DD202608090001', userId: 'user-1', userNickname: '林夏', userPhone: '13800000001', storeId: '1', storeName: '高新科技园店', status: OrderStatus.PendingAccept, paymentStatus: PaymentStatus.Paid, paymentMethod: PaymentMethod.Wechat, deliveryType: DeliveryType.Drone, items: [{ id: 'item-1', productId: 'prod-1', productName: '云顶拿铁', specificationText: '冰 / 大杯', quantity: 2, unitPrice: 2700, totalAmount: 5400 }], goodsAmount: 5400, discountAmount: 500, deliveryFee: 300, payableAmount: 5200, paidAmount: 5200, pickupNo: 'A018', remark: '少冰', createdAt: '2026-08-09 09:42:18' },
  { id: 'order-2', orderNo: 'DD202608090002', userId: 'user-2', userNickname: '周可', userPhone: '13800000002', storeId: '2', storeName: '万象城店', status: OrderStatus.Delivering, paymentStatus: PaymentStatus.Paid, paymentMethod: PaymentMethod.Balance, deliveryType: DeliveryType.Drone, items: [{ id: 'item-2', productId: 'prod-2', productName: '桂花乌龙轻乳茶', specificationText: '大杯 / 少糖', quantity: 1, unitPrice: 2300, totalAmount: 2300 }], goodsAmount: 2300, discountAmount: 0, deliveryFee: 500, payableAmount: 2800, paidAmount: 2800, pickupNo: 'B026', createdAt: '2026-08-09 10:05:36' },
  { id: 'order-3', orderNo: 'DD202608080118', userId: 'user-3', userNickname: '陈予', userPhone: '13800000003', storeId: '1', storeName: '高新科技园店', status: OrderStatus.Completed, paymentStatus: PaymentStatus.Paid, paymentMethod: PaymentMethod.Wechat, deliveryType: DeliveryType.Pickup, items: [{ id: 'item-3', productId: 'prod-3', productName: '黑金芝士蛋糕', quantity: 1, unitPrice: 3000, totalAmount: 3000 }], goodsAmount: 3000, discountAmount: 0, deliveryFee: 0, payableAmount: 3000, paidAmount: 3000, pickupNo: 'C011', createdAt: '2026-08-08 18:12:04' },
]

const refunds = [
  { id: 'refund-1', refundNo: 'TK202608090001', orderId: 'order-1', orderNo: 'DD202608090001', userId: 'user-1', amount: 5200, reason: '配送等待时间过长', status: RefundStatus.Reviewing, channel: 'WECHAT', createdAt: '2026-08-09 10:12:00' },
  { id: 'refund-2', refundNo: 'TK202608080014', orderId: 'order-3', orderNo: 'DD202608080118', userId: 'user-3', amount: 3000, reason: '用户取消', status: RefundStatus.Refunded, channel: 'BALANCE', createdAt: '2026-08-08 18:30:00' },
]

const complaints = [
  { id: 'complaint-1', orderId: 'order-1', type: 'COMPLAINT', content: '配送等待时间较长，希望优化配送提醒。', status: 'PENDING', reply: '', createdAt: now },
  { id: 'complaint-2', orderId: 'order-3', type: 'SUGGESTION', content: '希望自提完成后增加更明显的取餐提醒。', status: 'RESOLVED', reply: '已记录建议，后续会结合门店提醒一起优化。', createdAt: '2026-08-08 18:40:00' },
]

const deliveryRules = [
  { id: 'rule-1', storeId: '1', storeName: '高新科技园店', name: '科技园标准配送', minOrderAmount: 2000, baseFee: 400, freeThreshold: 6000, perKmFee: 100, startDistanceKm: 2, maxDistanceKm: 8, createdAt: now },
  { id: 'rule-2', storeId: '2', storeName: '万象城店', name: '商圈即时配送', minOrderAmount: 0, baseFee: 300, freeThreshold: 5000, perKmFee: 120, startDistanceKm: 1, maxDistanceKm: 5, createdAt: now },
  { id: 'rule-3', name: '全门店兜底规则', minOrderAmount: 1500, baseFee: 500, freeThreshold: 7000, perKmFee: 150, startDistanceKm: 3, maxDistanceKm: 10, createdAt: now },
]

const deliveryAreas = [
  { id: 'area-1', storeId: '1', storeName: '高新科技园店', type: 'RADIUS', radiusKm: 5, feeTier: 0, sort: 1 },
  { id: 'area-2', storeId: '2', storeName: '万象城店', type: 'POLYGON', polygon: '104.10,30.65;104.13,30.65;104.13,30.68;104.10,30.68', feeTier: 200, sort: 2 },
]

const users = [
  { id: 'user-1', nickname: '林夏', phone: '13800000001', roles: ['STORE_STAFF'], permissions: ['order:view', 'order:edit'], hasOrderManagePermission: true, level: 'BLACK', levelName: '黑金会员', points: 3280, growth: 12600, balance: 18800, frozen: 0, orders: 42, amount: 96800, last: '2026-08-09 09:42:18', status: 'ACTIVE', createdAt: '2026-05-01 12:00:00', updatedAt: now },
  { id: 'user-2', nickname: '周可', phone: '13800000002', level: 'GOLD', levelName: '黄金会员', points: 1680, growth: 6200, balance: 5600, frozen: 0, orders: 18, amount: 42600, last: '2026-08-09 10:05:36', status: 'ACTIVE', createdAt: '2026-05-18 12:00:00', updatedAt: now },
  { id: 'user-3', nickname: '陈予', phone: '13800000003', level: 'SILVER', levelName: '白银会员', points: 420, growth: 1800, balance: 0, frozen: 0, orders: 6, amount: 12800, last: '2026-08-08 18:12:04', status: 'FROZEN', createdAt: '2026-06-08 12:00:00', updatedAt: now },
]

const walletLogs = [
  { id: 'wallet-1', userId: 'user-1', nickname: '林夏', changeAmount: 10000, balanceAfter: 18800, type: 'RECHARGE', bizType: 'RECHARGE', bizId: 'recharge-1', remark: '充值 100 元', createdAt: '2026-08-08 12:10:00' },
  { id: 'wallet-2', userId: 'user-1', nickname: '林夏', changeAmount: -5200, balanceAfter: 13600, type: 'CONSUME', bizType: 'ORDER', bizId: 'order-1', remark: '订单支付', createdAt: '2026-08-09 09:42:18' },
]

const pointsLogs = [
  { id: 'points-1', userId: 'user-1', nickname: '林夏', changePoints: 52, pointsAfter: 3280, type: 'GAIN', bizType: 'ORDER', bizId: 'order-1', remark: '订单支付积分', createdAt: '2026-08-09 09:42:18' },
  { id: 'points-2', userId: 'user-2', nickname: '周可', changePoints: -200, pointsAfter: 1680, type: 'USE', bizType: 'ORDER', bizId: 'order-2', remark: '积分抵扣', createdAt: '2026-08-09 10:05:36' },
]

const memberLevels = [
  { id: 'level-1', code: 'NORMAL', name: '普通会员', growthThreshold: 0, discountRate: 10, pointsMultiplier: 1, badge: '默认', sort: 1 },
  { id: 'level-2', code: 'GOLD', name: '黄金会员', growthThreshold: 5000, discountRate: 9.5, pointsMultiplier: 1.2, badge: '金色', sort: 2 },
  { id: 'level-3', code: 'BLACK', name: '黑金会员', growthThreshold: 10000, discountRate: 8.8, pointsMultiplier: 1.5, badge: '黑金', sort: 3 },
]

const growthRules = [
  { id: 'growth-1', ruleType: '订单实付', param: '每消费 1 元得 1 成长值', enabled: true },
  { id: 'growth-2', ruleType: '首次下单', param: '一次性赠送 200 成长值', enabled: true },
]

const pointsRules = [
  { id: 'points-1', ruleType: '订单支付', calcMethod: '实付金额/100', value: 1, maxUsePerOrder: 500, enabled: true },
  { id: 'points-2', ruleType: '签到奖励', calcMethod: '固定值', value: 5, maxUsePerOrder: 0, enabled: true },
]

const memberBenefits = [
  { id: 'benefit-1', levelCode: 'GOLD', benefitType: '生日券', config: '生日月发放 10 元券', enabled: true, sort: 1 },
  { id: 'benefit-2', levelCode: 'BLACK', benefitType: '免配送费', config: '每月 4 次免配送费', enabled: true, sort: 2 },
]

const coupons = [
  { id: 'coupon-1', name: '新人满 30 减 8', type: 'CASH', amount: 800, threshold: 3000, validType: 'DAYS', validDays: 7, totalCount: 1000, issuedCount: 328, perUserLimit: 1, storeIds: '1,2', productScope: 'ALL', status: 'ENABLED', createdAt: now },
  { id: 'coupon-2', name: '黑金会员 9 折券', type: 'DISCOUNT', discountRate: 9, threshold: 0, validType: 'RANGE', validFrom: '2026-08-01', validTo: '2026-08-31', totalCount: 500, issuedCount: 86, perUserLimit: 2, storeIds: '1', productScope: 'DRINK', status: 'ENABLED', createdAt: now },
]

const banners = [
  { id: 'banner-1', title: '新品上市', imageUrl: 'https://example.com/banner1.png', linkType: 'PRODUCT', linkValue: 'prod-1', sort: 1, enabled: true, startAt: '2026-08-01 00:00:00', endAt: '2026-08-31 23:59:59' },
  { id: 'banner-2', title: '会员日专享', imageUrl: 'https://example.com/banner2.png', linkType: 'PAGE', linkValue: '/pages/member/index', sort: 2, enabled: true, startAt: '', endAt: '' },
]

const rechargePackages = [
  { id: 'recharge-1', name: '充 100 送 10', amount: 10000, giftBalance: 1000, giftCouponTemplateIds: 'coupon-1', sort: 1, status: 'ENABLED' },
  { id: 'recharge-2', name: '充 300 送 45', amount: 30000, giftBalance: 4500, giftCouponTemplateIds: 'coupon-1,coupon-2', sort: 2, status: 'ENABLED' },
]

const cardTemplates = [
  { id: 'card-1', name: '外卖免配卡', category: 'COUNT_CARD', salePrice: 1990, countValue: 10, validDays: 30, benefit: '单次最高抵扣 8 元配送费', totalCount: 500, issuedCount: 128, perUserLimit: 1, storeIds: '1,2', status: 'ENABLED', createdAt: now },
  { id: 'card-2', name: '咖啡储值卡', category: 'BALANCE_CARD', salePrice: 8800, faceValue: 10000, validDays: 180, benefit: '适用于全部饮品', totalCount: 300, issuedCount: 72, perUserLimit: 3, storeIds: '1,2,3', status: 'ENABLED', createdAt: now },
]

const groupBuys = [
  { id: 'group-1', name: '双人拿铁拼团', productId: 'prod-1', productName: '云顶拿铁', groupPrice: 3990, teamSize: 2, durationHours: 24, storeId: '1', status: 'ENABLED', startAt: '2026-08-09 08:00:00', endAt: '2026-08-16 23:59:59' },
]

const bargains = [
  { id: 'bargain-1', name: '芝士蛋糕砍价', productId: 'prod-3', productName: '黑金芝士蛋糕', floorPrice: 1990, initPrice: 3000, helpTimes: 5, storeId: '2', status: 'DRAFT' },
]

const flashSales = [
  { id: 'flash-1', name: '午间冷萃秒杀', storeId: '1', startAt: '2026-08-09 12:00:00', endAt: '2026-08-09 14:00:00', status: 'ENABLED', items: [{ productId: 'prod-4', productName: '冷萃美式', salePrice: 1290, limitQuantity: 1, stock: 80, sold: 24 }] },
]

const inviteConfigs = [
  { id: 'invite-1', scene: '拉新首单', inviterCouponTemplateId: 'coupon-1', inviteeCouponTemplateId: 'coupon-1', maxTimes: 20, enabled: true },
]

const pointsMallItems: MockPointsMallItem[] = [
  { id: 'pm-item-1', type: 'COUPON', name: '饮品满20减5券', description: '满 20 减 5', points: 260, stock: 3286, limitPerUser: 1, couponTemplateId: 'coupon-1', couponTemplateName: '新人满 30 减 8', badge: '热门', sort: 1, status: 'ON_SHELF', createdAt: now },
  { id: 'pm-item-2', type: 'COUPON', name: '配送立减3元券', description: '外送订单立减', points: 180, stock: 1120, limitPerUser: 2, couponTemplateId: 'coupon-2', couponTemplateName: '黑金会员 9 折券', badge: '低门槛', sort: 2, status: 'ON_SHELF', createdAt: now },
  { id: 'pm-item-3', type: 'PHYSICAL', name: '青屿随行杯', description: '门店自提周边', image: 'https://example.com/cup.png', points: 1280, stock: 36, limitPerUser: 1, pickupType: 'STORE_PICKUP', pickupDesc: '兑换后 7 天内到门店领取', badge: '周边', sort: 3, status: 'ON_SHELF', createdAt: now },
  { id: 'pm-item-4', type: 'PHYSICAL', name: '云咖帆布袋', description: '7 天内门店领取', image: 'https://example.com/bag.png', points: 980, stock: 8, limitPerUser: 1, pickupType: 'STORE_PICKUP', pickupDesc: '兑换后 7 天内到门店领取', sort: 4, status: 'ON_SHELF', createdAt: now },
  { id: 'pm-item-5', type: 'PHYSICAL', name: '限定甜品兑换卡', description: '指定甜品 1 份', image: 'https://example.com/dessert.png', points: 680, stock: 0, limitPerUser: 1, pickupType: 'STORE_PICKUP', pickupDesc: '到店领取', badge: '新品', sort: 5, status: 'OFF_SHELF', createdAt: now },
]

const pointsMallExchanges: MockPointsMallExchange[] = [
  { id: 'pm-exchange-1', itemId: 'pm-item-1', itemName: '饮品满20减5券', type: 'COUPON', pointsCost: 260, couponId: 'user-coupon-1', status: 'COMPLETED', nickname: '林夏', phone: '13800000001', createdAt: now },
  { id: 'pm-exchange-2', itemId: 'pm-item-3', itemName: '青屿随行杯', type: 'PHYSICAL', pointsCost: 1280, pickupCode: 'PM202608310001', status: 'PENDING_PICKUP', nickname: '周可', phone: '13800000002', createdAt: now },
]

const admins = [
  { id: 'admin-1', username: 'admin', nickname: '演示管理员', phone: '13900000001', roles: ['超级管理员'], permissions: ['*'], storeIds: ['1', '2', '3'], status: 'ENABLED', createdAt: '2026-07-01 09:00:00' },
  { id: 'admin-2', username: 'store_mgr', nickname: '门店经理', phone: '13900000002', roles: ['门店店长'], permissions: [Permission.StoreView, Permission.OrderEdit], storeIds: ['1'], status: 'ENABLED', createdAt: '2026-07-10 09:00:00' },
]

const roles = [
  { id: 'role-1', name: '超级管理员', code: 'SUPER_ADMIN', dataScope: 'ALL', permissions: ['*'], status: 'ENABLED' },
  { id: 'role-2', name: '门店店长', code: 'STORE_MANAGER', dataScope: 'STORE', permissions: [Permission.StoreView, Permission.OrderEdit], status: 'ENABLED' },
]

const operationLogs = [
  { id: 'log-1', operatorId: 'admin-1', operatorName: '演示管理员', module: '订单中心', action: '更新订单状态', ip: '127.0.0.1', createdAt: '2026-08-09 10:20:00' },
  { id: 'log-2', operatorId: 'admin-2', operatorName: '门店经理', module: '商品中心', action: '调整库存', ip: '127.0.0.1', createdAt: '2026-08-09 09:58:00' },
]

const systemParams = [
  { id: 'param-1', key: 'ORDER_AUTO_CANCEL_MINUTES', value: '15', groupName: '订单配置', remark: '未支付自动取消分钟数', updatedAt: now },
  { id: 'param-2', key: 'STORE_DEFAULT_OPEN_TIME', value: '09:00', groupName: '门店配置', remark: '默认营业开始时间', updatedAt: now },
]

const paymentConfigs = [
  { id: 'pay-1', channel: 'WECHAT', appId: 'wx-demo-appid', mchId: '1900000001', notifyUrl: 'https://demo.example.com/pay/notify', enabled: true, configStatus: 'SET' },
  { id: 'pay-2', channel: 'BALANCE', enabled: true, configStatus: 'SET' },
]

const printers = [
  { id: 'printer-1', name: '高新前台打印机', storeId: '1', storeName: '高新科技园店', deviceKey: 'P-0001', status: 'ONLINE', printScope: '订单小票', lastHeartbeatAt: now, createdAt: '2026-07-20 10:00:00' },
  { id: 'printer-2', name: '万象厨房打印机', storeId: '2', storeName: '万象城店', deviceKey: 'P-0002', status: 'PAPER_OUT', printScope: '后厨标签', lastHeartbeatAt: '2026-08-09 09:50:00', createdAt: '2026-07-22 10:00:00' },
]

const messageLogs = [
  { id: 'msg-log-1', scene: 'ORDER', receiver: '13800000001', channel: 'WECHAT', status: 'SUCCESS', sentAt: '2026-08-09 09:42:20' },
  { id: 'msg-log-2', scene: 'REFUND', receiver: '13800000003', channel: 'SMS', status: 'PENDING', sentAt: '2026-08-09 10:12:30' },
]

const messageTemplates = [
  { id: 'msg-tpl-1', code: 'ORDER_PAID', scene: 'ORDER', title: '订单支付成功', content: '您的订单 {orderNo} 已支付成功。', status: 'ENABLED', updatedAt: now },
  { id: 'msg-tpl-2', code: 'REFUND_RESULT', scene: 'REFUND', title: '退款结果通知', content: '您的退款申请已处理。', status: 'ENABLED', updatedAt: now },
]

const messageConfig = [
  { id: 'msg-cfg-1', scene: 'ORDER', enabled: true, channel: 'WECHAT' },
  { id: 'msg-cfg-2', scene: 'REFUND', enabled: true, channel: 'SMS' },
  { id: 'msg-cfg-3', scene: 'MARKETING', enabled: false, channel: 'APP_PUSH' },
]

const verificationLogs = [
  { id: 'verify-1', verifyNo: 'HX202608090001', code: 'HX-901248', bizType: 'PICKUP_ORDER', orderId: 'order-3', orderNo: 'DD202608080118', storeId: '1', storeName: '高新科技园店', userId: 'user-3', userNickname: '陈予', result: 'SUCCESS', createdAt: '2026-08-08 18:30:00' },
  { id: 'verify-2', verifyNo: 'HX202608090002', code: 'HX-901249', bizType: 'PICKUP_ORDER', orderId: 'order-2', orderNo: 'DD202608090002', storeId: '2', storeName: '万象城店', userId: 'user-2', userNickname: '周可', result: 'DUPLICATE', failReason: '核销码已使用', createdAt: '2026-08-09 10:18:00' },
]

const financeTransactions = [
  { id: 'txn-1', transactionNo: 'ZF202608090001', orderNo: 'DD202608090001', channel: 'WECHAT', amount: 5200, status: 'SUCCESS', createdAt: '2026-08-09 09:42:18' },
  { id: 'txn-2', transactionNo: 'ZF202608090002', orderNo: 'DD202608090002', channel: 'BALANCE', amount: 2800, status: 'SUCCESS', createdAt: '2026-08-09 10:05:36' },
  { id: 'txn-3', transactionNo: 'ZF202608090003', orderNo: 'DD202608090003', channel: 'WECHAT', amount: 4200, status: 'PROCESSING', createdAt: '2026-08-09 10:22:00' },
]

const reconciliation = [
  { storeId: '1', storeName: '高新科技园店', orderCount: 126, totalAmount: 368800, settledAmount: 368800, diffAmount: 0, status: 'BALANCED' },
  { storeId: '2', storeName: '万象城店', orderCount: 84, totalAmount: 226500, settledAmount: 225900, diffAmount: 600, status: 'PENDING' },
  // 后端会把 store_id IS NULL 的订单聚成 storeId='0' + 空 storeName 的一行，这里保留同样形状，
  // 用来验证前端不会把它渲染成裸的 "0"。
  { storeId: '0', storeName: '', orderCount: 3, totalAmount: 8600, settledAmount: 0, diffAmount: 8600, status: 'PENDING' },
]

const dataOverview = {
  date: '2026-08-09',
  revenueToday: 89500,
  revenueYesterday: 76800,
  orderCountToday: 128,
  orderCountYesterday: 116,
  refundCountToday: 3,
  refundCountYesterday: 4,
  metrics: [
    { metric: '营业额', today: '¥895.00', yesterday: '¥768.00', trend: '上升' },
    { metric: '订单数', today: '128', yesterday: '116', trend: '上升' },
    { metric: '退款单', today: '3', yesterday: '4', trend: '下降' },
  ],
}

const dailyOrders = [
  { label: '08-03', value: 92 },
  { label: '08-04', value: 106 },
  { label: '08-05', value: 118 },
  { label: '08-06', value: 109 },
  { label: '08-07', value: 124 },
  { label: '08-08', value: 116 },
  { label: '08-09', value: 128 },
]

const statusDistribution = [
  { label: OrderStatus.PendingAccept, value: 8 },
  { label: OrderStatus.Producing, value: 12 },
  { label: OrderStatus.Delivering, value: 9 },
  { label: OrderStatus.Completed, value: 96 },
  { label: OrderStatus.Refunding, value: 3 },
]

const storeRank = [
  { storeId: '1', storeName: '高新科技园店', orderCount: 126, revenue: 368800, avgPrice: 2927 },
  { storeId: '2', storeName: '万象城店', orderCount: 84, revenue: 226500, avgPrice: 2696 },
  { storeId: '3', storeName: '大学城店', orderCount: 52, revenue: 132600, avgPrice: 2550 },
]

const hotProducts = [
  { productId: 'prod-1', productName: '云顶拿铁', sales: 328, salesAmount: 787200 },
  { productId: 'prod-2', productName: '桂花乌龙轻乳茶', sales: 276, salesAmount: 579600 },
  { productId: 'prod-3', productName: '黑金芝士蛋糕', sales: 91, salesAmount: 273000 },
]

const dashboardOverview = {
  todayOrderCount: 128,
  todayRevenue: 89500,
  monthRevenue: 1826800,
  pendingOrderCount: 8,
  pendingRefundCount: 3,
  totalUsers: 1268,
  totalStores: 3,
  trend: dailyOrders,
  statusDistribution,
  storeRank,
  hotProducts,
}

export function isAdminMockEnabled(): boolean {
  return import.meta.env.VITE_USE_MOCK === 'true'
}

export function getAdminMockResponse(config: AxiosRequestConfig): MockResult {
  const method = (config.method ?? 'GET').toUpperCase()
  const path = normalizePath(config.url)
  const params = (config.params ?? {}) as QueryParams

  if (method !== 'GET') {
    if (method === 'POST' && path === '/auth/login') return handled({ token: 'mock-token', user: mockAdminUser })
    if (method === 'POST' && path === '/auth/change-password') return handled(undefined)
    if (method === 'POST' && path === '/complaints/reply') {
      const { id, reply } = readData(config) as { id: string; reply: string }
      const complaint = complaints.find(c => c.id === id)
      if (complaint) {
        complaint.reply = reply
        return handled(undefined)
      }
      return handled(undefined)
    }
    if (method === 'POST' && path === '/complaints/status') {
      const { id, status } = readData(config) as { id: string; status: string }
      const complaint = complaints.find(c => c.id === id)
      if (complaint) {
        complaint.status = status
        return handled(undefined)
      }
      return handled(undefined)
    }
    if (method === 'POST' && path === '/products') return handled(saveMockProduct(readData(config)))
    if (method === 'PUT' && path.match(/^\/products\/[^/]+$/)) return handled(saveMockProduct({ ...readData(config), id: path.split('/')[2] }))
    if (method === 'POST' && path === '/skus') return handled(saveMockSku(readData(config)))
    if (method === 'PUT' && path.match(/^\/skus\/[^/]+$/)) return handled(saveMockSku({ ...readData(config), id: path.split('/')[2] }))
    if (method === 'POST' && path === '/categories') return handled(saveMockCategory(readData(config)))
    if (method === 'PUT' && path.match(/^\/categories\/[^/]+$/)) return handled(saveMockCategory({ ...readData(config), id: path.split('/')[2] }))
    if (method === 'POST' && path === '/member-levels') return handled(createMockMemberLevel(readData(config)))
    if (method === 'PUT' && path.match(/^\/member-levels\/[^/]+$/)) return handled(saveMockMemberLevel({ ...readData(config), id: path.split('/')[2] }))
    if (method === 'DELETE' && path.match(/^\/products\/[^/]+$/)) return handled(deleteMockProduct(path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/categories\/[^/]+$/)) return handled(deleteMockCategory(path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/member-levels\/[^/]+$/)) return handled(deleteMockItem(memberLevels, path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/combos\/[^/]+$/)) return handled(deleteMockItem(combos, path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/skus\/[^/]+$/)) return handled(deleteMockSku(path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/extras\/[^/]+$/)) return handled(deleteMockItem(extras, path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/coupons\/[^/]+$/)) return handled(deleteMockItem(coupons, path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/marketing\/banners\/[^/]+$/)) return handled(deleteMockItem(banners, path.split('/')[3] ?? ''))
    if (method === 'DELETE' && path.match(/^\/recharge-packages\/[^/]+$/)) return handled(deleteMockItem(rechargePackages, path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/card-templates\/[^/]+$/)) return handled(deleteMockItem(cardTemplates, path.split('/')[2] ?? ''))
    if (method === 'DELETE' && path.match(/^\/marketing\/group-buy\/[^/]+$/)) return handled(deleteMockItem(groupBuys, path.split('/')[3] ?? ''))
    if (method === 'DELETE' && path.match(/^\/marketing\/bargain\/[^/]+$/)) return handled(deleteMockItem(bargains, path.split('/')[3] ?? ''))
    if (method === 'DELETE' && path.match(/^\/marketing\/flash-sale\/[^/]+$/)) return handled(deleteMockItem(flashSales, path.split('/')[3] ?? ''))
    if (method === 'DELETE' && path.match(/^\/marketing\/invite\/[^/]+$/)) return handled(deleteMockItem(inviteConfigs, path.split('/')[3] ?? ''))
    if (method === 'POST' && path === '/admin/points-mall/items') return handled(saveMockPointsMallItem(readData(config)))
    if (method === 'PUT' && path === '/admin/points-mall/items') return handled(saveMockPointsMallItem(readData(config)))
    if (method === 'DELETE' && path.match(/^\/admin\/points-mall\/items\/[^/]+$/)) return handled(deleteMockItem(pointsMallItems, path.split('/')[4] ?? ''))
    if (method === 'PATCH' && path.match(/^\/admin\/points-mall\/items\/[^/]+\/status$/)) return handled(updateMockPointsMallItemStatus(path.split('/')[4] ?? '', readData(config).status))
    if (method === 'POST' && path.match(/^\/admin\/points-mall\/exchanges\/[^/]+\/pickup$/)) return handled(pickupMockPointsMallExchange(path.split('/')[4] ?? '', readData(config).pickupRemark))
    if (method === 'DELETE' && path.match(/^\/printers\/[^/]+$/)) return handled(deleteMockItem(printers, path.split('/')[2] ?? ''))
    if (method === 'POST' && path.match(/^\/orders\/refunds\/[^/]+\/audit$/)) return handled(auditMockRefund(path.split('/')[3] ?? '', readData(config).result))
    if (method === 'PUT' && path.match(/^\/orders\/[^/]+\/status$/)) return handled(updateMockOrderStatus(path.split('/')[2] ?? '', readData(config).status))
    if (method === 'PUT' && path.match(/^\/users\/[^/]+\/status$/)) return handled(updateMockUserStatus(path.split('/')[2] ?? '', readData(config).status))
    if (method === 'PUT' && path.match(/^\/users\/[^/]+\/admin-permission$/)) return handled(updateMockUserAdminPermission(path.split('/')[2] ?? '', readData(config)))
    if (method === 'PUT' && path.match(/^\/users\/[^/]+\/balance$/)) return handled(adjustMockUserBalance(path.split('/')[2] ?? '', readData(config).amount))
    if (method === 'PUT' && path.match(/^\/users\/[^/]+\/points$/)) return handled(adjustMockUserPoints(path.split('/')[2] ?? '', readData(config).points))
    if (method === 'DELETE' && path.match(/^\/users\/[^/]+$/)) return handled(deleteMockUser(path.split('/')[2] ?? ''))
    if (method === 'PUT' && path === '/inventory') return handled(findById(inventory, 'skuId', readData(config).skuId) ?? inventory[0])
    return handled(undefined)
  }

  if (path === '/auth/me') return handled(mockAdminUser)
  if (path === '/dashboard/overview') return handled(dashboardOverview)
  if (path === '/orders') return handled(page(filterOrders(orders, params), params))
  if (path.match(/^\/orders\/refunds\/[^/]+\/wechat-status$/)) return handled(refreshMockWechatRefundStatus(path.split('/')[3] ?? ''))
  if (path.startsWith('/orders/')) return handled(findById(orders, 'id', path.split('/')[2]) ?? orders[0])
  if (path === '/refunds') return handled(page(refunds, params))
  if (path === '/complaints') return handled(page(complaints, params))
  if (path === '/stores') return handled(filterStores(stores, params))
  if (path.match(/^\/stores\/[^/]+\/stats$/)) return handled(storeStats(path.split('/')[2] ?? ''))
  if (path === '/products') return handled(page(filterProducts(products, params), params))
  if (path === '/categories') return handled(categories)
  if (path === '/skus') return handled(filterByOptional(skus, 'productId', params.productId))
  if (path === '/extras') return handled(extras)
  if (path === '/inventory') return handled(page(inventory, params))
  if (path === '/combos') return handled(combos)
  if (path === '/member-levels') return handled(memberLevels)
  if (path.match(/^\/member-levels\/[^/]+$/)) return handled(memberLevels.find((item) => item.id === path.split('/')[2]))
  if (path === '/growth-rules') return handled(growthRules)
  if (path === '/points-rules') return handled(pointsRules)
  if (path === '/member-benefits') return handled(memberBenefits)
  if (path === '/delivery/rules') return handled(deliveryRules)
  if (path === '/delivery/areas') return handled(deliveryAreas)
  if (path === '/users') return handled(page(filterUsers(users, params), params))
  if (path.match(/^\/users\/[^/]+$/)) return handled(findById(users, 'id', path.split('/')[2]) ?? users[0])
  if (path.match(/^\/users\/[^/]+\/wallet-logs$/)) return handled(page(filterByOptional(walletLogs, 'userId', path.split('/')[2]), params))
  if (path.match(/^\/users\/[^/]+\/points-logs$/)) return handled(page(filterByOptional(pointsLogs, 'userId', path.split('/')[2]), params))
  if (path === '/coupons') return handled(page(coupons, params))
  if (path === '/marketing/banners') return handled(banners)
  if (path === '/recharge-packages') return handled(rechargePackages)
  if (path === '/card-templates') return handled(cardTemplates)
  if (path === '/marketing/group-buy') return handled(groupBuys)
  if (path === '/marketing/bargain') return handled(bargains)
  if (path === '/marketing/flash-sale') return handled(flashSales)
  if (path === '/marketing/invite') return handled(inviteConfigs)
  if (path === '/admin/points-mall/items') return handled(page(filterPointsMallItems(pointsMallItems, params), params))
  if (path === '/admin/points-mall/exchanges') return handled(page(filterPointsMallExchanges(pointsMallExchanges, params), params))
  if (path === '/system/admins') return handled(page(admins, params))
  if (path === '/system/roles') return handled(roles)
  if (path === '/system/logs') return handled(page(operationLogs, params))
  if (path === '/system/params') return handled(systemParams)
  if (path === '/payment-config') return handled(paymentConfigs)
  if (path === '/printers') return handled(printers)
  if (path === '/messages') return handled(page(messageLogs, params))
  if (path === '/message-templates') return handled(messageTemplates)
  if (path === '/message-config') return handled(messageConfig)
  if (path === '/verification/logs') return handled(page(filterVerificationLogs(verificationLogs, params), params))
  if (path === '/finance/transactions') return handled(page(financeTransactions, params))
  if (path === '/finance/refunds') return handled(page(refunds, params))
  if (path === '/finance/reconciliation') return handled(page(reconciliation, params))
  if (path === '/data/overview') return handled(dataOverview)
  if (path === '/data/orders') return handled({ paidCount: 125, cancelCount: 4, refundCount: 3, dailyOrders, statusDistribution })
  if (path === '/data/products') return handled({ movingProductCount: 18, bestSeller: '云顶拿铁', bestSellerSales: 328, slowMovingCount: 2, items: hotProducts })
  if (path === '/data/stores') return handled(storeRank)

  return { handled: false }
}

function handled(data: unknown): MockResult {
  return { handled: true, data: clone(data) }
}

function clone<T>(value: T): T {
  if (value === undefined) return value
  return JSON.parse(JSON.stringify(value)) as T
}

function normalizePath(url?: string): string {
  if (!url) return '/'
  const path = url.startsWith('http') ? new URL(url).pathname : url
  return path.split('?')[0] || '/'
}

function page<T>(list: T[], params: QueryParams): PageResult<T> {
  const pageNo = Number(params.page ?? 1) || 1
  const pageSize = Number(params.pageSize ?? 10) || 10
  const start = (pageNo - 1) * pageSize
  return {
    list: list.slice(start, start + pageSize),
    page: pageNo,
    pageSize,
    total: list.length,
    hasMore: start + pageSize < list.length,
  }
}

function findById<T extends Record<string, unknown>>(list: T[], key: string, id: unknown): T | undefined {
  return list.find((item) => String(item[key]) === String(id))
}

function filterByOptional<T extends Record<string, unknown>>(list: T[], key: string, value: unknown): T[] {
  if (!value) return list
  return list.filter((item) => String(item[key]) === String(value))
}

function includes(value: unknown, keyword: unknown): boolean {
  if (!keyword) return true
  return String(value ?? '').toLowerCase().includes(String(keyword).toLowerCase())
}

function filterStores(list: typeof stores, params: QueryParams): typeof stores {
  return list.filter((item) => includes(`${item.name}${item.code}`, params.keyword) && (!params.status || item.businessStatus === params.status))
}

function filterProducts(list: typeof products, params: QueryParams): typeof products {
  return list.filter((item) =>
    includes(`${item.name}${item.subtitle ?? ''}`, params.keyword)
    && (!params.categoryId || item.categoryId === params.categoryId)
    && (!params.status || item.status === params.status),
  )
}

function filterOrders(list: typeof orders, params: QueryParams): typeof orders {
  return list.filter((item) =>
    includes(item.orderNo, params.orderNo)
    && includes(item.userPhone, params.phone)
    && (!params.storeId || item.storeId === params.storeId)
    && (!params.status || item.status === params.status)
    && (!params.deliveryType || item.deliveryType === params.deliveryType),
  )
}

function filterUsers(list: typeof users, params: QueryParams): typeof users {
  return list.filter((item) =>
    includes(`${item.nickname ?? ''}${item.phone ?? ''}`, params.keyword)
    && (!params.level || item.level === params.level)
    && (!params.adminPermission
      || (params.adminPermission === 'ENABLED' && item.hasOrderManagePermission)
      || (params.adminPermission === 'DISABLED' && !item.hasOrderManagePermission)),
  )
}

function filterVerificationLogs(list: typeof verificationLogs, params: QueryParams): typeof verificationLogs {
  return list.filter((item) =>
    includes(item.code, params.code)
    && includes(item.orderNo, params.orderNo)
    && (!params.result || item.result === params.result),
  )
}

function filterPointsMallItems(list: typeof pointsMallItems, params: QueryParams): typeof pointsMallItems {
  return list.filter((item) =>
    includes(`${item.name}${item.description ?? ''}`, params.keyword)
    && (!params.type || item.type === params.type)
    && (!params.status || item.status === params.status),
  )
}

function filterPointsMallExchanges(list: typeof pointsMallExchanges, params: QueryParams): typeof pointsMallExchanges {
  return list.filter((item) =>
    includes(`${item.itemName}${item.nickname ?? ''}${item.phone ?? ''}`, params.keyword)
    && (!params.type || item.type === params.type)
    && (!params.status || item.status === params.status),
  )
}

function storeStats(storeId: string): unknown {
  const storeOrders = orders.filter((item) => item.storeId === storeId)
  return {
    storeId,
    todayOrderCount: storeOrders.length,
    todayRevenue: storeOrders.reduce((sum, item) => sum + item.paidAmount, 0),
    monthOrderCount: storeOrders.length * 12,
    monthRevenue: storeOrders.reduce((sum, item) => sum + item.paidAmount, 0) * 12,
  }
}

function updateMockOrderStatus(orderId: string, status: unknown): void {
  const order = orders.find((item) => item.id === orderId)
  if (order && status) order.status = status as OrderStatus
}

function auditMockRefund(refundId: string, result: unknown): void {
  const refund = refunds.find((item) => item.id === refundId)
  if (!refund) return
  refund.status = result === 'REJECTED' ? RefundStatus.Rejected : RefundStatus.Refunding
}

function refreshMockWechatRefundStatus(refundId: string): unknown {
  const refund = refunds.find((item) => item.id === refundId)
  if (refund?.channel === 'WECHAT' && refund.status === RefundStatus.Refunding) {
    refund.status = RefundStatus.Refunded
  }
  return {
    refundNo: refund?.refundNo ?? refundId,
    orderNo: refund?.orderNo ?? '',
    refundStatus: refund?.status ?? RefundStatus.Closed,
    wechatStatus: refund?.status === RefundStatus.Refunded ? 'SUCCESS' : 'PROCESSING',
    wechatRefundId: refund?.channel === 'WECHAT' ? `wx-refund-${refund.id}` : '',
    message: refund?.status === RefundStatus.Refunded ? '微信退款已成功' : '微信退款处理中',
    refundedAt: refund?.status === RefundStatus.Refunded ? now : '',
  }
}

function updateMockUserStatus(userId: string, status: unknown): void {
  const user = users.find((item) => item.id === userId)
  if (user && status) {
    user.status = String(status)
    user.updatedAt = now
  }
}

function updateMockUserAdminPermission(userId: string, payload: Record<string, unknown>): typeof users[number] | undefined {
  const user = users.find((item) => item.id === userId)
  if (!user) return undefined
  const enabled = Boolean(payload.enabled)
  user.hasOrderManagePermission = enabled
  user.roles = enabled ? (payload.roles as string[] | undefined) ?? ['STORE_STAFF'] : []
  user.permissions = enabled ? (payload.permissions as string[] | undefined) ?? ['order:view', 'order:edit'] : []
  user.updatedAt = now
  return user
}

function adjustMockUserBalance(userId: string, amount: unknown): void {
  const user = users.find((item) => item.id === userId)
  const value = Number(amount ?? 0)
  if (user && value) {
    user.balance = (user.balance ?? 0) + value
    user.updatedAt = now
  }
}

function adjustMockUserPoints(userId: string, points: unknown): void {
  const user = users.find((item) => item.id === userId)
  const value = Number(points ?? 0)
  if (user && value) {
    user.points = (user.points ?? 0) + value
    user.updatedAt = now
  }
}

function deleteMockUser(userId: string): void {
  const index = users.findIndex((item) => item.id === userId)
  if (index >= 0) users.splice(index, 1)
}

function saveMockPointsMallItem(payload: Record<string, unknown>): void {
  const coupon = coupons.find((item) => item.id === payload.couponTemplateId)
  const item = {
    id: String(payload.id || `pm-item-${Date.now()}`),
    type: String(payload.type || 'COUPON'),
    name: String(payload.name || ''),
    description: String(payload.description || ''),
    image: String(payload.image || ''),
    points: Number(payload.points || 0),
    stock: Number(payload.stock || 0),
    limitPerUser: Number(payload.limitPerUser || 0),
    couponTemplateId: String(payload.couponTemplateId || ''),
    couponTemplateName: coupon?.name || '',
    pickupType: String(payload.pickupType || ''),
    pickupDesc: String(payload.pickupDesc || ''),
    badge: String(payload.badge || ''),
    sort: Number(payload.sort || 0),
    status: String(payload.status || 'ON_SHELF'),
    createdAt: String(payload.createdAt || now),
  }
  const index = pointsMallItems.findIndex((candidate) => candidate.id === item.id)
  if (index >= 0) pointsMallItems.splice(index, 1, item)
  else pointsMallItems.push(item)
}

function updateMockPointsMallItemStatus(id: string, status: unknown): void {
  const item = pointsMallItems.find((candidate) => candidate.id === id)
  if (item && status) item.status = String(status)
}

function pickupMockPointsMallExchange(id: string, pickupRemark: unknown): void {
  const item = pointsMallExchanges.find((candidate) => candidate.id === id)
  if (!item || item.status !== 'PENDING_PICKUP') return
  item.status = 'PICKED_UP'
  item.pickupRemark = String(pickupRemark || '')
  item.pickedUpAt = now
}

function saveMockProduct(payload: Record<string, unknown>): void {
  const category = categories.find((item) => item.id === payload.categoryId)
  const product = {
    id: String(payload.id || `prod-${Date.now()}`),
    name: String(payload.name || ''),
    categoryId: String(payload.categoryId || ''),
    categoryName: category?.name || '',
    storeIds: payload.storeIds === undefined || payload.storeIds === null ? null : String(payload.storeIds),
    storeNames: null,
    subtitle: String(payload.subtitle || ''),
    mainImageUrl: String(payload.mainImageUrl || ''),
    originalPrice: Number(payload.originalPrice || 0),
    price: Number(payload.originalPrice || 0),
    status: String(payload.status || 'ON'),
    supportsDelivery: payload.supportsDelivery !== false,
    stock: Number(payload.stock || 0),
    sales: Number(payload.sales || 0),
    createdAt: String(payload.createdAt || now),
    specGroups: normalizeSpecGroups(payload.specGroups),
  }
  const index = products.findIndex((item) => item.id === product.id)
  if (index >= 0) products.splice(index, 1, product)
  else products.push(product)
}

function saveMockCategory(payload: Record<string, unknown>): void {
  const category = {
    id: String(payload.id || `cat-${Date.now()}`),
    name: String(payload.name || ''),
    parentId: String(payload.parentId || ''),
    tab: String(payload.tab || ''),
    iconUrl: String(payload.iconUrl || ''),
    sort: Number(payload.sort || categories.length + 1),
    status: String(payload.status || 'ENABLED'),
    supportsDelivery: payload.supportsDelivery !== false,
    createdAt: String(payload.createdAt || now),
  }
  const index = categories.findIndex((item) => item.id === category.id)
  if (index >= 0) categories.splice(index, 1, category)
  else categories.push(category)
}

function normalizeSpecGroups(value: unknown): Array<{
  id: string
  name: string
  required: boolean
  multiple: boolean
  options: Array<{ id: string; name: string; priceInFen: number; enabled: boolean; sort?: number; recommended?: boolean }>
}> {
  if (!Array.isArray(value)) return []
  return value.map((group, groupIndex) => {
    const source = group as Record<string, unknown>
    const options = Array.isArray(source.options) ? source.options : []
    return {
      id: String(source.id || `group-${groupIndex + 1}`),
      name: String(source.name || ''),
      required: source.required !== false,
      multiple: Boolean(source.multiple),
      options: options.map((option, optionIndex) => {
        const item = option as Record<string, unknown>
        return {
          id: String(item.id || `option-${optionIndex + 1}`),
          name: String(item.name || ''),
          priceInFen: Number(item.priceInFen || 0),
          enabled: item.enabled !== false,
          sort: item.sort === undefined ? undefined : Number(item.sort),
          recommended: item.recommended === undefined ? undefined : Boolean(item.recommended),
        }
      }),
    }
  })
}

function saveMockSku(payload: Record<string, unknown>): void {
  const product = products.find((item) => item.id === payload.productId)
  const sku = {
    id: String(payload.id || `sku-${Date.now()}`),
    productId: String(payload.productId || ''),
    productName: product?.name || '',
    skuCode: String(payload.skuCode || ''),
    specText: String(payload.specText || ''),
    price: Number(payload.price || 0),
    memberPrice: Number(payload.memberPrice || 0),
    enabled: payload.enabled !== false,
    stock: Number(payload.stock || 0),
  }
  const index = skus.findIndex((item) => item.id === sku.id)
  if (index >= 0) skus.splice(index, 1, sku)
  else skus.push(sku)
}

function deleteMockCategory(categoryId: string): void {
  deleteMockItem(categories, categoryId)
  for (let index = products.length - 1; index >= 0; index -= 1) {
    if (products[index]?.categoryId === categoryId) deleteMockProduct(products[index]?.id ?? '')
  }
}

function deleteMockProduct(productId: string): void {
  deleteMockItem(products, productId)
  for (let index = skus.length - 1; index >= 0; index -= 1) {
    if (skus[index]?.productId === productId) deleteMockSku(skus[index]?.id ?? '')
  }
  combos.forEach((combo) => {
    combo.items = combo.items.filter((item) => item.productId !== productId)
  })
}

function deleteMockSku(skuId: string): void {
  deleteMockItem(skus, skuId)
  for (let index = inventory.length - 1; index >= 0; index -= 1) {
    if (inventory[index]?.skuId === skuId) inventory.splice(index, 1)
  }
}

function createMockMemberLevel(payload: Record<string, unknown>): typeof memberLevels[number] {
  const level = {
    ...payload,
    id: `member-level-${Date.now()}`,
  } as typeof memberLevels[number]
  memberLevels.push(level)
  return level
}

function saveMockMemberLevel(payload: Record<string, unknown>): typeof memberLevels[number] {
  const level = payload as typeof memberLevels[number]
  const index = memberLevels.findIndex((item) => item.id === level.id)
  if (index >= 0) memberLevels.splice(index, 1, level)
  return level
}

function deleteMockItem<T extends { id: string }>(items: T[], id: string): void {
  const index = items.findIndex((item) => item.id === id)
  if (index >= 0) items.splice(index, 1)
}

function readData(config: AxiosRequestConfig): Record<string, unknown> {
  if (!config.data) return {}
  if (typeof config.data === 'string') {
    try {
      return JSON.parse(config.data) as Record<string, unknown>
    } catch {
      return {}
    }
  }
  return config.data as Record<string, unknown>
}
